/**
 * Added to shelves that are automatically added by [IVAR, BROR, ..] for stability reason.
 */
class StabilityComponent {
    constructor() {
        this.typeId = StabilityComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
StabilityComponent.id = 2023;
export default StabilityComponent;
//# sourceMappingURL=StabilityComponent.js.map